import { render } from "./BonusNew.vue?vue&type=template&id=51484c4e&scoped=true"
import script from "./BonusNew.vue?vue&type=script&lang=js"
export * from "./BonusNew.vue?vue&type=script&lang=js"

import "./BonusNew.vue?vue&type=style&index=0&id=51484c4e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51484c4e"]])

export default __exports__